"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripSourceCanEditEstimate = exports.tripSourceDescription = exports.tripSourceDeserialize = exports.tripSourceAllKnownInOrder = exports.tripSourceAllKnown = void 0;
const sentenceCase_1 = __importDefault(require("../util/sentenceCase"));
const deserializeString_1 = require("./deserializeString");
/**
 * All known trip sources (we may add more in the future)
 */
exports.tripSourceAllKnown = [
    'ADMIN_PORTAL',
    'ANDROID',
    'CUSTOMER_PORTAL',
    'DISPATCH_API',
    'DISPATCH_PORTAL',
    'EZ_CATER',
    'IOS',
    'OLO',
    'SLACK',
];
exports.tripSourceAllKnownInOrder = [
    'ADMIN_PORTAL',
    'CUSTOMER_PORTAL',
    'DISPATCH_PORTAL',
    'SLACK',
    'DISPATCH_API',
    'EZ_CATER',
    'OLO',
    'ANDROID',
    'IOS',
];
function tripSourceDeserialize(value) {
    const string = (0, deserializeString_1.deserializeString)(value);
    if (string === 'REACT_NATIVE_RIDER' || string === 'RIDER_REACT_NATIVE') {
        return 'IOS';
    }
    return string;
}
exports.tripSourceDeserialize = tripSourceDeserialize;
function tripSourceDescription(source) {
    switch (source) {
        case 'ADMIN_PORTAL':
            return 'Admin Portal';
        case 'ANDROID':
            return 'Android';
        case 'CUSTOMER_PORTAL':
            return 'Customer portal';
        case 'DISPATCH_API':
            return 'WaveBytes';
        case 'DISPATCH_PORTAL':
            return 'Dispatch Portal';
        case 'EZ_CATER':
            return 'ezCater';
        case 'IOS':
            return 'iOS';
        case 'OLO':
            return 'OLO';
        case 'SLACK':
            return 'Slack';
        default:
            return (0, sentenceCase_1.default)(source);
    }
}
exports.tripSourceDescription = tripSourceDescription;
function tripSourceCanEditEstimate(source) {
    switch (source) {
        case 'ADMIN_PORTAL':
        case 'DISPATCH_PORTAL':
        case 'EZ_CATER':
        case 'SLACK':
            return true;
        default:
            return false;
    }
}
exports.tripSourceCanEditEstimate = tripSourceCanEditEstimate;
